// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"568":"b4a7a72c","783":"cf0fbeae"}[chunkId] + ".chunk.css";
};